import { i as isFunction } from "./is-function.js";
const unFunction = (fn, ...args) => {
  if (isFunction(fn)) {
    return fn(...args);
  }
  return fn;
};
export {
  unFunction as u
};
//# sourceMappingURL=un-function.js.map
